<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
 

import Basic from "./basic";

/**
 * Leaflet-map component
 */
export default {
  page: {
    title: "Leaflet map", 
  },
  components: {
    Layout,
    PageHeader,
    Basic,

  },
  data() {
    return {
      title: "Leaflet",
      items: [
        {
          text: "Maps",
          href: "/"
        },
        {
          text: "Leaflet",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <b-card-title class="mb-4">Example</b-card-title>
            <Basic class="leaflet-map" />
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>
  </Layout>
</template>